<template>
  <div class="unit-and-picker">
    <SelectCom
      v-model="unitType"
      :options="unitTypes"
      size="large"
      width="80px"
      :clearable="false"
      class="regionId-select-com"
    />
    <el-date-picker
      v-show="unitType === 'all'"
      v-model="startAndEndTime"
      :disabled="true"
      type="daterange"
      align="center"
      size="large"
      unlink-panels
      range-separator="至"
      start-placeholder="开始日期"
      end-placeholder="结束日期"
      format="yyyy-MM-dd"
      value-format="yyyy-MM-dd"
      :picker-options="pickerOptions"
      style="width: 240px"
      :clearable="false"
    ></el-date-picker>
    <el-date-picker
      v-show="unitType === 'day'"
      v-model="dayTime"
      type="date"
      placeholder="选择日期"
      style="width: 240px"
      :picker-options="pickerOptions"
      value-format="yyyy-MM-dd"
      :clearable="false"
    >
    </el-date-picker>
    <el-date-picker
      v-show="unitType === 'week'"
      v-model="weekTime"
      type="week"
      format="yyyy 第 WW 周"
      value-format="yyyy-MM-dd"
      placeholder="选择周"
      style="width: 240px"
      :picker-options="pickerOptions"
      :clearable="false"
    >
    </el-date-picker>
    <el-date-picker
      v-show="unitType === 'month'"
      v-model="monthTime"
      type="month"
      placeholder="选择月"
      style="width: 240px"
      value-format="yyyy-MM-dd"
      :picker-options="pickerOptions"
      :clearable="false"
    >
    </el-date-picker>
  </div>
</template>

<script>
import SelectCom from './SelectCom'
import moment from 'moment'
import _ from 'lodash'
import constant from '@/utils/constant'
import { mapGetters } from 'vuex'

export default {
  name: 'DateUnitAndPicker',
  components: {
    SelectCom,
  },
  props: {
    areaId: [String, Number],
  },
  data() {
    return {
      unitType: '',
      unitTypes: [
        {
          value: 'all',
          label: '全部',
        },
        {
          value: 'day',
          label: '日',
        },
        {
          value: 'week',
          label: '周',
        },
        {
          value: 'month',
          label: '月',
        },
      ],
      startAndEndTime: [],
      dayTime: '',
      weekTime: '',
      monthTime: '',
    }
  },
  computed: {
    ...mapGetters({
      userDetail: 'customer/userDetail',
    }),
    agentAreas() {
      return _.get(this.userDetail, 'agentAreas', [])
    },
    formatStartAt() {
      let startAt = constant.startDate
      if (this.areaId) {
        const curArea = _.find(
          this.agentAreas,
          item => item.id === +this.areaId
        )
        if (moment(curArea.beginAt) > moment(startAt)) {
          startAt = curArea.beginAt
        }
      }
      return moment(startAt).format('YYYY-MM-DD')
    },
    yesterdayDate() {
      return moment().subtract(1, 'days').format('YYYY-MM-DD')
    },
    pickerOptions() {
      return {
        firstDayOfWeek: 1,
        disabledDate: time => {
          if (this.unitType === 'week') {
            return (
              moment(this.formatStartAt) > moment(time) ||
              moment().subtract(1, 'weeks') < moment(time)
            )
          }
          if (this.unitType === 'month') {
            return (
              moment(this.formatStartAt) > moment(time) ||
              moment().subtract(1, 'months') < moment(time)
            )
          }
          return (
            moment(this.formatStartAt) > moment(time) ||
            moment().subtract(1, 'days') < moment(time)
          )
        },
      }
    },
    filterTimes() {
      let startTime = ''
      let endTime = ''
      if (this.unitType === 'all') {
        startTime = this.startAndEndTime[1]
        endTime = this.startAndEndTime[1]
      }
      if (this.unitType === 'day') {
        startTime = this.dayTime
        endTime = this.dayTime
      }
      if (this.unitType === 'week') {
        const weekEndDate = moment(this.weekTime)
          .endOf('week')
          .add(1, 'days')
          .format('YYYY-MM-DD')
        startTime = weekEndDate
        endTime = weekEndDate
      }
      if (this.unitType === 'month') {
        const monthEndDate = moment(this.monthTime)
          .endOf('month')
          .format('YYYY-MM-DD')
        startTime = monthEndDate
        endTime = monthEndDate
      }
      return {
        unit: this.unitType,
        startTime,
        endTime,
      }
    },
  },
  watch: {
    areaId() {
      this.unitType = 'all'
    },
    unitType: {
      handler(unit) {
        if (unit === 'all') {
          this.startAndEndTime = [this.formatStartAt, this.yesterdayDate]
        }
        if (unit === 'day') {
          this.dayTime = this.yesterdayDate
        }
        if (unit === 'week') {
          this.weekTime = moment(this.yesterdayDate)
            .subtract(1, 'weeks')
            .format('YYYY-MM-DD')
        }
        if (unit === 'month') {
          this.monthTime = moment(this.yesterdayDate)
            .subtract(1, 'months')
            .format('YYYY-MM-DD')
        }
      },
      immediate: true,
    },
    filterTimes: {
      handler(params) {
        this.$emit('changeTimes', params)
      },
      immediate: true,
    },
  },
  created() {
    this.unitType = 'all'
  },
}
</script>

<style lang='scss'>
.unit-and-picker {
  display: flex;
  .regionId-select-com {
    margin-right: 16px;
  }
}
</style>